import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { actions as extraProductActions } from "../../../../../ancillaries/store/extraProducts/actions.js";
import useGetUrlParams from "../../../../../hooks/useGetUrlParams.js";
import { useDispatch, useSelector } from "react-redux";
import tph_flights_price_discrepancy_aa from "../../../../../utils/experiments/funnel/tph_flights_price_discrepancy_aa.js";
import { getFlightDetailsFetchStatus } from "../../../../../store/flightDetails/selectors.js";
import useProfiler from "../../../../../hooks/useProfiler.js";
export function useFlightDetailsFooterEffectsMobile(props) {
    const { flight, isFlexTicket } = props;
    const history = useHistory();
    const dispatch = useDispatch();
    const { getUrlParam } = useGetUrlParams();
    const { isLoggedInAuthLow } = useProfiler();
    const fetchStatus = useSelector(getFlightDetailsFetchStatus);
    useEffect(() => {
        if (isFlexTicket) {
            dispatch(extraProductActions.addPreOptInProduct("flexibleTicket", true));
            return;
        }
        dispatch(extraProductActions.removePreOptInProduct("flexibleTicket"));
    }, [dispatch, isFlexTicket]);
    useEffect(() => {
        if (fetchStatus !== "success" || !flight)
            return;
        const wishlistPriceParam = getUrlParam("wishlistPrice");
        const adplat = getUrlParam("adplat");
        if (!wishlistPriceParam || !adplat || !adplat.includes("wishlist-flight")) {
            return;
        }
        const [priceStr, currency] = wishlistPriceParam.split("_");
        const wishlistValue = Number(priceStr);
        if (!currency || isNaN(wishlistValue))
            return;
        const fdTotal = flight.priceBreakdown.total;
        if (fdTotal.currencyCode !== currency)
            return;
        if (!isLoggedInAuthLow())
            return;
        tph_flights_price_discrepancy_aa.goals.flight_details_price_loaded();
        const fdValue = fdTotal.units * 1e9 + fdTotal.nanos;
        if (wishlistValue === fdValue) {
            tph_flights_price_discrepancy_aa.goals.price_match();
            tph_flights_price_discrepancy_aa.goalsWithValue.tph_flights_price_match_count(1);
        }
        else if (wishlistValue > fdValue) {
            tph_flights_price_discrepancy_aa.goals.price_mismatch_wishlist_higher();
            tph_flights_price_discrepancy_aa.goalsWithValue.tph_flights_price_mismatch_wishlist_higher_count(1);
        }
        else {
            tph_flights_price_discrepancy_aa.goals.price_mismatch_wishlist_lower();
            tph_flights_price_discrepancy_aa.goalsWithValue.tph_flights_price_mismatch_wishlist_lower_count(1);
        }
        const params = new URLSearchParams(window.location.search);
        params.delete("wishlistPrice");
        history.replace(`${window.location.pathname}?${params.toString()}${window.location.hash}`);
    }, [fetchStatus, flight, getUrlParam, history, isLoggedInAuthLow]);
    return {};
}
